import {
  CalendarDateIcon,
  LayersTwo01Icon,
  PlusSquareIcon,
} from "@vetty/icons";
import { Button, Select, Tabs, TabsItem } from "@/components";
import {
  GROUP_KIND_FILTER_OPTIONS,
  GROUP_PERIOD_OPTIONS,
  GROUP_TAB_ITEMS,
  type GroupKindFilter,
  type GroupPeriodFilter,
  type GroupToolbarTab,
} from "../../_constants/groups.const";
import styles from "./GroupsToolbar.module.scss";

type GroupsToolbarProps = {
  tab: GroupToolbarTab;
  kind: GroupKindFilter;
  period: GroupPeriodFilter;
  onTabChange: (value: GroupToolbarTab) => void;
  onKindChange: (value: GroupKindFilter) => void;
  onPeriodChange: (value: GroupPeriodFilter) => void;
  /** Omit when create is not implemented — hides the no-op Create group control. */
  onCreateGroupClick?: () => void;
};

export const GroupsToolbar = ({
  tab,
  kind,
  period,
  onTabChange,
  onKindChange,
  onPeriodChange,
  onCreateGroupClick,
}: GroupsToolbarProps) => {
  return (
    <div className={styles["comp"]}>
      <div className={styles["comp__left"]}>
        <Tabs
          value={tab}
          onChange={(value) => onTabChange(value as GroupToolbarTab)}
          variant="secondary"
          size="medium"
        >
          {GROUP_TAB_ITEMS.map((item) => (
            <TabsItem key={item.value} value={item.value}>
              {item.label}
            </TabsItem>
          ))}
        </Tabs>

        <div className={styles["comp__filters"]}>
          <Select
            size="medium"
            variant="secondary"
            value={kind}
            startContent={<LayersTwo01Icon style={{ width: 20, height: 20 }} />}
            onChange={(value) => onKindChange(value as GroupKindFilter)}
          >
            {GROUP_KIND_FILTER_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Select>

          <Select
            size="medium"
            variant="secondary"
            value={period}
            startContent={<CalendarDateIcon style={{ width: 20, height: 20 }} />}
            onChange={(value) => onPeriodChange(value as GroupPeriodFilter)}
          >
            {GROUP_PERIOD_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Select>
        </div>
      </div>

      {onCreateGroupClick ? (
        <div className={styles["comp__actions"]}>
          <Button
            size="medium"
            variant="primary"
            startContent={<PlusSquareIcon style={{ width: 20, height: 20 }} />}
            onClick={onCreateGroupClick}
          >
            Create group
          </Button>
        </div>
      ) : null}
    </div>
  );
};
